import { render, staticRenderFns } from "./ChatbotRestored.vue?vue&type=template&id=53279a2f&scoped=true"
import script from "./ChatbotRestored.vue?vue&type=script&lang=js"
export * from "./ChatbotRestored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53279a2f",
  null
  
)

export default component.exports